<template>
  <div>
    <card :class="'card-'+theme" class="col-lg-12 col-md-12" style="min-height: 340px; max-height: 375px;" v-if="!$auth.user().subscription">
      <div class="card-header">
        <h4 class="card-title">
          <i class="nc-icon nc-notification-70"></i> Avisos
        </h4>
      </div>
      <hr>
      <div class="card-body">
        <div class="text-center">
          <h2 class="card-title text-center">
            <small>Oops. Wall Street, we have a problem...</small>
          </h2>
          <h2 class="card-title text-center">
            <small>
              Você não possui assinatura ativa
              para continuar acompanhando os avisos da Área do Aluno.
            </small>
          </h2>
          <br>
          <router-link
            class="btn btn-round btn-fill"
            :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
            to="/signature"
            href="/performance"
          >Nova Assinatura</router-link>
        </div>
      </div>
    </card>
    <card v-if="$auth.user().subscription" :class="'card-'+theme">
      <div class="row" v-if="loadingNoticeMessages" v-loading="loadingNoticeMessages" id="loading"></div>
      <div v-if="!loadingNoticeMessages" class="table-responsive">
        <!-- <h4 class="card-title text-center text-danger">
          <i class="nc-icon nc-notification-70"></i>
          Fique atento aos avisos da Academia Top Trader:
        </h4> -->
        <h4 class="text-center mt-1 mb-1"> Avisos </h4>
        <br>
        <table class="table" :class="'card-title-'+theme">
          <tr>
            <th width="20%">Recebido em:</th>
            <th width="30%">Assunto:</th>
            <th width="60%">Aviso</th>
          </tr>
          <tr v-for="(noticeMessage, index) in noticeMessages.data" :key="noticeMessage.id">
            <td width="20%">{{noticeMessage.created_at.date | moment("DD/MM/YYYY")}}</td>
            <td width="30%">{{noticeMessage.subject}}</td>
            <td width="50%">{{noticeMessage.boby}}</td>
          </tr>
        </table>
        <hr>
        <h4 class="card-title text-right">
          <small class="text-white">
            <a
              class="btn btn-round btn-fill text-white"
              :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
              v-if="loadingDoneText!=='Não há avisos registrados.'"
              @click.prevent="loadMore()"
            >
              <i class="nc-icon nc-circle"></i> Carregar Mais
            </a>
            <br>
            {{ loadingDoneText }}
          </small>
        </h4>
      </div>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import { Loading, Dialog } from "element-ui";
import moment from "moment-timezone";

moment.tz.setDefault("America/Sao_Paulo");
Vue.use(Loading.directive);

export default {
  components: {},
  data() {
    return {
      loadingNoticeMessages: true,
      loadingDoneText: "",
      page: 1,
      noticeMessages: {
        data: [],
        meta: {
          pagination: {
            total: 0
          }
        }
      }
    };
  },
  methods: {
    fetchNoticeMessages() {
      this.page = 1;
      this.axios
        .get("/notices?page=" + this.page)
        .then(response => {
          this.noticeMessages.data = response.data.data;
          this.loadingNoticeMessages = false;
          if (this.noticeMessages.data.length == 0) {
            this.loadingDoneText = "Não há avisos registrados.";
          }
        })
        .catch(error => {
          console.log(error);
          alert("Erro ao carregar avisos. Tente novamente \n." + error);
        });
    },
    loadMore() {
      this.loadingNoticeMessages = true;
      this.page++;
      this.axios
        .get("/notices?page=" + this.page)
        .then(response => {
          this.loadingNoticeMessages = false;
          if (response.data.data.length === 0) {
            this.loadingDoneText = "Todos os avisos carregados com sucesso.";
          } else {
            this.noticeMessages.data = this.noticeMessages.data.concat(
              response.data.data
            );
          }
        })
        .catch(error => {
          this.loadingNoticeMessages = false;
          console.log(error);
          alert("Erro ao carregar mais avisos. Tente novamente \n. " + error);
        });
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchNoticeMessages();
  }
};
</script>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }

  .el-loading-mask {
    background: transparent !important;
  }
}

.el-dialog {
  width: 50%;
}
@media (max-width: 800px) {
  .el-dialog {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Notice.vue